import { themeStyle } from '@src/theming';
import styled, { css } from 'styled-components';

import { H6, H7 } from '../Typography';

import { TagProps } from './types';

const rounds = {
  xs: '4px',
  full: '10000px',
};

const paddings = {
  s: '4px 8px',
  m: '6px 12px',
  l: '8px 12px',
};

const heights = {
  s: '24px',
  m: '28px',
  l: '32px',
};

const gaps = {
  s: '6px',
  m: '7px',
  l: '8px',
};

type TagContainerProps = Pick<
  Required<TagProps>,
  'size' | 'maxWidth' | 'round' | 'isActive'
> & {
  isHoverable?: boolean;
};

const hoverableStyles = css`
  &:hover {
    background-color: ${themeStyle.varTransparentBlack};
    cursor: pointer;

    ${H6}, ${H7} {
      color: ${themeStyle.varInkMain};
    }
  }
`;

export const TagContainer = styled.div<TagContainerProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  max-width: ${({ maxWidth }) => maxWidth};
  gap: ${({ size }) => gaps[size]};
  height: ${({ size }) => heights[size]};
  padding: ${({ size }) => paddings[size]};
  border-radius: ${({ round }) => rounds[round]};
  background-color: ${({ isActive }) =>
    isActive ? themeStyle.varBackgroundAlt : themeStyle.varInkSuperLight};
  border: 1px solid ${themeStyle.varInkLight};

  ${H6}, ${H7} {
    color: ${themeStyle.varInkMedium};
  }

  ${({ isHoverable }) => isHoverable && hoverableStyles}
`;

export const CloseIconWrapper = styled.div`
  display: flex;

  cursor: pointer;
`;
